module.exports = __webpack_public_path__ + "static/media/kiw.d960b841.png";